import { render } from "./BaseBarsArrowDown.vue?vue&type=template&id=943a1bc8"
const script = {}

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__